// ============================================================
// Крупный предпросмотр картинки карты при наведении на миниатюру.
// Общий для «Выбора карты и мода» и «Менеджера матча». Стили: `.rr-map-preview`.
// ============================================================

let previewEl: HTMLElement | null = null;

export function hideMapPreview(): void {
    previewEl?.remove();
    previewEl = null;
}

/** Показывает крупную картинку рядом с миниатюрой (с учётом краёв окна). */
export function showMapPreview(src: string, anchor: HTMLElement, name?: string): void {
    hideMapPreview();
    const box = document.createElement('div');
    box.className = 'rr-map-preview';
    const img = document.createElement('img');
    img.src = src;
    img.alt = '';
    box.appendChild(img);
    // Подпись нужна в плитке, где на самой карточке названия нет
    if (name) {
        const caption = document.createElement('div');
        caption.className = 'rr-map-preview-name';
        caption.textContent = name;
        box.appendChild(caption);
    }
    document.body.appendChild(box);

    const r = anchor.getBoundingClientRect();
    const b = box.getBoundingClientRect();
    const pad = 8;

    let left = r.right + 12;
    if (left + b.width > window.innerWidth - pad) left = window.innerWidth - b.width - pad;
    if (left < pad) left = pad;

    let top = r.top;
    if (top + b.height > window.innerHeight - pad) top = window.innerHeight - b.height - pad;
    if (top < pad) top = pad;

    box.style.left = `${left}px`;
    box.style.top = `${top}px`;
    previewEl = box;
}
